export default {
  authLoading: (state) => state.authLoading,
};
